import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { RigidRegistration } from '~/domain/patient/rigidRegistration';
import useSelectedPatient from '~/hooks/patient/useSelectedPatient';
import { replanningRunRegistrationsState } from '~/state/atoms/adaptiveReplanningAtoms';
import { useRunScans } from './useRunScans';

// The run's own rigid between its two scans; none while the run has not returned one.
export function useRunRigidRegistration(): RigidRegistration | undefined {
    const patient = useSelectedPatient();
    const { planning, target } = useRunScans();
    const runUids = useRecoilValue(replanningRunRegistrationsState);
    return useMemo(() => {
        if (!patient || !planning || !target) {
            return undefined;
        }
        return patient
            .findRegistrationsBetween(target, planning)
            .find((candidate) => runUids.includes(candidate.sopInstanceUid));
    }, [patient, planning, target, runUids]);
}
